<template>
    <div>
        <div class="mt-3">
            <h4 class="text-center">Create Building</h4>
            <hr>
            <BuildingRegistrationComponent :buildingInformation="buildingInformation" :apiMethod="apiMethod">
                <div slot="SuccessMessage">
                    <transition name="fade">
                        <div class="alert alert-success">Building has been created.</div>
                    </transition>
                </div>
            </BuildingRegistrationComponent>
        </div>
    </div>
</template>

<script>
  import BuildingRegistrationComponent from '../../../../components/building-registration/BuildingRegistrationComponent.vue'

  export default {
    components: {
      BuildingRegistrationComponent
    },
    data () {
      return {
        buildingInformation: {
          name: undefined,
          contract_no: undefined,
          strata_no: undefined,
          latitude: undefined,
          longitude: undefined,
          address: undefined,
          suburb: undefined,
          post_code: undefined,
          state: undefined,
          key: undefined,
          parking: undefined,
          toilet: undefined,
          note: undefined,
          inner: undefined,
          email_template: 'emiot',
        },
        apiMethod: {
          method: 'POST',
          path: 'api/v1/sites',
          path_template: '/api/buildings',
          section: 'fixture',
        }
      }
    }
  }
</script>